









































































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app';
import Alert from '@/components/Shared/Alert.vue';
import UserType from '@/models/Users/UserType';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import SSOProvider from '@/models/Agencies/SSOProvider';

@Component({
  name: 'Login', components: { Alert }
})
export default class extends GiganautVue {

  private loginForm = {
    username: '',
    password: '',
  }

  private showPasswordField = false;
  private loading = false;

  async resetPassword() {
    this.$router.push({ name: PageNames.ResetPassword});
  }

  changeEmail() {
    this.showPasswordField = false;
    this.loginForm.password = '';
  }

  async handleSubmit() {
    if (!this.showPasswordField) {
      // Step 1: Email entered, lookup provider
      await this.lookupProvider();
    } else {
      // Step 2: Password entered, login with Firebase
      await this.login();
    }
  }

  async lookupProvider() {
    if (!this.loginForm.username) {
      AppModule.updateErrorMessage({ message: 'Please enter your email address', code: 'VALIDATION_ERROR', isOutOfDate: false });
      return;
    }

    this.loading = true;
    try {
      const provider = await AppModule.lookupAuthProvider(this.loginForm.username);

      if (provider === 'firebase') {
        // Show password field for Firebase email/password auth
        this.showPasswordField = true;
      } else if (provider === SSOProvider.Microsoft) {
        // Redirect to Microsoft Entra (will navigate away from page)
        await AppModule.initiateEntraLogin(this.loginForm.username);
        // Note: page will redirect, so no further processing needed
        return;
      }
    } catch (error) {
      // Error will be displayed by error handler
    } finally {
      this.loading = false;
    }
  }

  async login() {
    this.loading = true;
    try {
      await AppModule.firebaseLogin(this.loginForm);
      if (AppModule.currentUser === null) {
        return;
      }
      await this.handlePostLogin();
    } catch (error) {
      // Error will be displayed by error handler
    } finally {
      this.loading = false;
    }
  }

  async handlePostLogin() {
    await AppModule.getUserProfile();
    if (AppModule.userProfile.userType == UserType.Undefined) {
      //get profile failed - error will be displayed
      return;
    }
    switch (AppModule.userProfile.userType) {
      case UserType.Company: {
        //Every company has a permission to read the company record which contains the company ID
        // var companyID;
        // AppModule.userProfile.permissions.forEach(permission => {
        // if (permission.entityType === "Company" && permission.permission === "Company_Profile_Read") {
        //   companyID = permission.entityId;
        // }});
        //this.$router.push({ name: PageNames.CompanyBookings, params: { companyid: companyID } });
        break;
      }
      case UserType.SysAdmin: {
        this.$router.push({ name: PageNames.SysAdminAgencies });
        break;
      }
      case UserType.Agency: {
        //Get the current agency context for subsequent request headers
        await AppModule.getAgencyContext(AppModule.userProfile.agencyIdentifiers[0].id)
        //Check for redirect
        if (this.$route.query.redirect !== undefined) {
          this.$router.push({ path: this.$route.query.redirect.toString()});
          break;
        }
        this.$router.push({ name: PageNames.AgencyDashboard});
        break;
      }
    }
  }
}
